import cx from 'classnames';
import React from 'react';

import { ComponentProps } from './interfaces';
import * as Styled from './styled';

export const Layout: React.FC<ComponentProps> = ({
  children,
  showFooter = false,
  showLoading = false,
  contentPadding = 32,
  backgroundColor = '',
  mainBackgroundColor = '',
  className = '',
  hasTitle = true
}) => (
  <Styled.Wrapper
    mainBackgroundColor={mainBackgroundColor}
    showFooter={showFooter}
    className={cx({ [className]: !!className })}>
    <Styled.Container
      contentPadding={contentPadding}
      showLoading={showLoading}
      showFooter={showFooter}
      backgroundColor={backgroundColor}
      hasTitle={hasTitle}>
      {children}
    </Styled.Container>
  </Styled.Wrapper>
);

export default Layout;
